export const WINDOW_MODE_MOBILE_WIDTH = 640
export const WINDOW_MODE_TABLET_WIDTH = 1024
export const WINDOW_MODE_WEBSITE_HEIGHT = 600
